import { Box, TextField } from '@mui/material';
import MessageGroup from 'components/@home/@messages/ChatPanel/MessagesList/MessageGroup';
import Label from 'components/@home/drawers/AppDrawer/Form/Label';
import { HrBotContext } from 'components/@home/drawers/HrBotDrawer/hrBotContext';
import extractionFileMatchesForSend from 'components/@home/@documents/SentDocuments/extractionFileMatch';
import { getFileName } from 'components/@home/drawers/HrBotDrawer/pdf-utils';
import IphonePreview from 'components/common/IphonePreview';
import { func, object } from 'prop-types';
import React, { Fragment, memo, useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { I18n } from 'utils/i18n';
import { HR_BOT_APP_ID } from 'services/constants';

const StepMessage = ({ setError, setNextEnabled, userItems, setUserItems }) => {
  const app = useSelector(state => state.apps.apps[HR_BOT_APP_ID]);
  const { format, files, setMessage } = useContext(HrBotContext);
  const { message } = useContext(HrBotContext);
  const sendByField = format.sendBy || 'code';
  const file = useMemo(
    () =>
      files?.find(f => !f.error && extractionFileMatchesForSend(f, sendByField)) || { file: {} },
    [files, sendByField],
  );
  const name = useMemo(
    () => getFileName({ ...file, ...userItems }, format),
    [file, format, userItems],
  );
  const formatUserItems = useMemo(() => format.items.filter(i => i.selector === 'user'), [format]);
  useEffect(() => {
    setNextEnabled(!!message && formatUserItems.every(i => userItems[i.name]));
    setError(null);
  }, [formatUserItems, message, setError, setNextEnabled, userItems]);
  return (
    <Box sx={{ flexGrow: 1, width: '100%', display: 'flex', flexDirection: 'column', pr: '40px' }}>
      <Box
        sx={{
          width: '100%',
          mt: 1,
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        <div>
          <Label>{I18n.t('HrBot.Message')}</Label>
          <TextField
            sx={{ width: 290 }}
            multiline
            rows={20}
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          {formatUserItems.map(item => (
            <Fragment key={item.name}>
              <Label sx={{ textTransform: 'capitalize' }}>
                {I18n.t(`HrBot.fields.${item.name}`)}
              </Label>
              <TextField
                sx={{ width: 290 }}
                rows={20}
                value={userItems[item.name]}
                onChange={e => {
                  const val = e.target?.value || '';
                  setUserItems(ui => {
                    return {
                      ...ui,
                      [item.name]: val,
                    };
                  });
                }}
              />
            </Fragment>
          ))}
        </div>
        <IphonePreview>
          <Box
            sx={muiTheme => ({
              zoom: 0.73,
              flexDirection: 'column',
              p: '10px',
              flexGrow: 1,
              backgroundColor: muiTheme.palette.secondary.ultraLight,
              display: 'flex',
              justifyContent: 'flex-end',
              fontSize: 14,
            })}
          >
            {message && (
              <MessageGroup
                msgRef={() => {}}
                message={{
                  text: message,
                  employee: {
                    avatar: app.avatar,
                    firstName: app.name,
                  },
                }}
              />
            )}
            {file && (
              <MessageGroup
                msgRef={() => {}}
                message={{
                  attachments: [
                    {
                      name,
                      httpLink: name,
                      mimeType: 'application/pdf',
                      type: 'doc',
                      size: file.file.size,
                    },
                  ],
                  employee: {
                    avatar: app.avatar,
                    firstName: app.name,
                  },
                }}
              />
            )}
          </Box>
        </IphonePreview>
      </Box>
    </Box>
  );
};

StepMessage.propTypes = {
  setError: func.isRequired,
  setNextEnabled: func.isRequired,
  userItems: object.isRequired,
  setUserItems: func.isRequired,
};

export default memo(StepMessage);
